<template>
  <v-container 
    id="contato"
    fluid
    py-0
  >
    <v-row class="">
      <v-col cols="12" md="6" class="pa-3 ma-0">
        <v-container
          :class="{
            'pa-12': $vuetify.breakpoint.mdAndUp,
            'pa-7': $vuetify.breakpoint.smAndDown,
          }"
          class=""
        >
          <h3 class="display-3 text-uppercase font-weight-regular black--text">
            <span class="barlow">Entre em Contato</span>
          </h3>
          <div class="">
            Como podemos ajudá-lo?
          </div>
          <v-list
            disabled
            class="pt-5"
            color="transparent"
          >
            <v-list-item-group color="primary">
              <v-list-item 
                v-for="(c,i) in contatos" :key="i"
                class='px-0 mx-0'
              >
                <v-list-item-icon>
                  <v-icon
                    :large="$vuetify.breakpoint.mdAndUp"
                   class="primary--text">{{ c.icone }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title 
                    :class="{
                      'title font-weight-regular': $vuetify.breakpoint.mdAndUp,
                      'subtitle-1': $vuetify.breakpoint.smAndDown,
                    }"
                  >{{ c.titulo }}</v-list-item-title>
                  <v-list-item-subtitle>{{ c.subtitulo }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-container>
      </v-col>
      <v-col cols="12" md="6"
        class="grey darken-4 pa-3"
      >
        <v-container
          :class="{
            'pa-12': $vuetify.breakpoint.mdAndUp,
            'pa-7': $vuetify.breakpoint.smAndDown,
          }"
        >
          <h3 class="display-3 text-uppercase font-weight-regular">
            <span class="barlow primary--text">Fale conosco</span>
          </h3>
          <v-form
            ref="form" dark
            v-model="valid"
            class="pt-5"
            :class="{
              'pr-10': $vuetify.breakpoint.mdAndUp,
            }"
          >
            <v-text-field
              v-model="form.nome"
              :rules="nomeRules"
              label="Nome"
              required
              dark
              color="primary"
            ></v-text-field>
            <v-text-field
              v-model="form.sobrenome"
              :rules="sobrenomeRules"
              label="Sobrenome"
              required
              dark
              color="primary"
            ></v-text-field>
            <v-text-field
              v-model="form.email"
              :rules="emailRules"
              label="E-mail"
              dark
              color="primary"
            ></v-text-field>
            <v-text-field
              v-model="form.whatsapp"
              :rules="whatsappRules"
              v-mask="mask"
              return-masked-value
              label="WhatsApp"
              dark
              color="primary"
            ></v-text-field>
            <v-text-field
              v-model="form.telefone"
              :rules="telefoneRules"
              v-mask="mask"
              return-masked-value
              label="Telefone"
              dark
              color="primary"
            ></v-text-field>
            <v-text-field
              v-model="form.observacoes"
              :rules="observacoesRules"
              label="Mensagem"
              dark
              color="primary"
            ></v-text-field>
            <div class="pt-5">
              <v-btn id="submit" 
                x-large
                block
                color="primary white--text"
                class="mt-4"
                @click="submit" 
                :loading="loading" 
                :disabled="loading"
              ><span class="title font-weight-medium">Enviar</span></v-btn>
            </div>
          </v-form>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import {mask} from 'vue-the-mask'
let qs = require('qs')

export default {
  directives: {mask},
  data: () => ({
    contatos: [
      {
        icone: 'mdi-map-marker',
        titulo: 'Fortaleza - CE',
        subtitulo: 'Av. Santos Dumont, 5554, Cocó'
      },
      {
        icone: 'mdi-phone',
        titulo: '(85) 98802-0486',
        subtitulo: ''
      },
      {
        icone: 'mdi-email',
        titulo: 'contato@institutoaltoimpacto.com.br',
        subtitulo: ''
      },
    ],
    form: {
      lista: 97,
      nome: '',
      sobrenome: '',
      email: '',
      whatsapp: '',
      observacoes: null
    },
    loading: false,
    valid: false,
    mask: '(##) #####-####',
    nomeRules: [
      (v) => !!v || 'Informe seu nome'
    ],
    sobrenomeRules: [
      (v) => !!v || 'Informe seu sobrenome'
    ],
    whatsappRules: [
      (v) => !!v || 'Informe seu WhatsApp'
    ],
    telefoneRules: [
      (v) => !!v || 'Informe seu telefone'
    ],
    emailRules: [
      (v) => !!v || 'Informe seu e-mail',
      //(v) => '/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/'.test(v) || 'Informe um e-mail válido'
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Informe um e-mail válido'
    ],
    observacoesRules: [
      (v) => !!v || 'Digite sua mensagem'
    ],
//    dialog: false
  }),
  methods: {
    submit () {
      var vm = this
//      vm.form.indicador = this.$route.params.indicador
      if (this.$refs.form.validate()) {
        // console.log('validou');
        // console.log('FORM',vm.form);

        let params = qs.stringify({
          form: vm.form
//            form: $("#form_inscricao").serialize()
        })
////          let formData = $("#form_inscricao").serialize()
//          console.log(params)
//      (p || {})
        vm.loading = true //the loading begin
        axios.post('https://api.otimizze.me/v0/leads/post2/', params)
          .then(response => {
            // console.log('AXIOS NEXT', response.data)
            vm.loading = false
            if (response.status === 200) {
              swal("Contato realizado com sucesso!", "Em breve entraremos em contato.", "success", {
                button: "Fechar"
              })
              vm.dialog = false

              // DISPARA EVENTO FACEBOOK
              //fbq('track', 'Lead')

              // DISPARA EVENTO GOOGLE
//              gtag('event', 'clique', {
//                'event_category': 'enviar'
//              })
//              console.log('evento disparado')

              //vm.$router.push({ path: '/obrigado' })
              //window.open('https://pag.ae/7UZDywNcL')
            } else if (response.status === "error") {
              console.error("Log >>> Erro na gravação");
            }
          }).catch(e => {
            console.error('AXIOS CATCH', e)
            vm.loading = false
          })
      }
      else {
        console.error('não validou')
      }
    },
  },
};
</script>